import CancelIcon from '@mui/icons-material/HighlightOffOutlined'
import AddIcon from '@mui/icons-material/AddCircleOutlineOutlined'

const columns = [
  { field: 'folio', label: 'N° Documento', width: 'w-[15%]' },
  { field: 'contraparte', label: 'Tipo de Documento', width: 'w-[20%]' },
  { field: 'tipoDocumento', label: 'Concepto', width: 'w-[30%]' },
  { field: 'monto', label: 'Monto', width: 'w-[15%]' },
  { field: 'notas', label: 'Notas', width: 'w-[20%]' }
]

const formatMonto = value => {
  const numericValue = String(value ?? '').replace(/\D/g, '')
  return numericValue ? new Intl.NumberFormat('es-CL').format(numericValue) : ''
}

const TablaRendicionGasto = ({ filasGastos, setFilasGastos, filaVacia }) => {
  const handleChangeFila = (index, field, value) => {
    setFilasGastos(prev =>
      prev.map((fila, i) => (i === index ? { ...fila, [field]: value } : fila))
    )
  }

  const agregarFila = () => {
    setFilasGastos(prev => [...prev, { ...filaVacia }])
  }

  const eliminarFila = index => {
    setFilasGastos(prev => (prev.length <= 1 ? prev : prev.filter((_, i) => i !== index)))
  }

  return (
    <div className='overflow-hidden rounded-xl border border-gray-200 bg-white shadow-sm'>
      <div className='overflow-x-auto'>
        <table className='w-full min-w-[800px] table-fixed border-collapse text-xs font-sans'>
          <caption className='sr-only'>Detalle de rendición de gastos</caption>
          <thead className='bg-gray-50'>
            <tr>
              {columns.map(({ field, label, width }) => (
                <th
                  key={field}
                  scope='col'
                  className={`${width} border-b border-gray-200 px-3 py-3 text-xs font-semibold text-gray-500 ${
                    field === 'monto' ? 'text-right' : 'text-left'
                  }`}
                >
                  {label}
                </th>
              ))}
              <th
                scope='col'
                className='w-24 border-b border-gray-200 px-3 py-3 text-center font-semibold text-gray-500'
              >
                Acciones
              </th>
            </tr>
          </thead>
          <tbody className='divide-y divide-gray-200'>
            {filasGastos.map((fila, index) => (
              <tr
                key={index}
                className='transition-colors hover:bg-gray-50 focus-within:bg-gray-50'
              >
                {columns.map(({ field, label }) => (
                  <td key={field} className='px-2 py-2 align-middle'>
                    <input
                      type='text'
                      inputMode={field === 'monto' ? 'numeric' : undefined}
                      aria-label={`${label}, fila ${index + 1}`}
                      placeholder={field === 'monto' ? '0' : 'Escribir...'}
                      className={`w-full rounded-md border border-gray-300 bg-white px-2 py-2 text-xs text-gray-700 shadow-sm transition-colors placeholder:text-gray-400 hover:border-gray-400 focus:border-accent2 focus:outline-none focus:ring-2 focus:ring-accent2/20 ${
                        field === 'monto' ? 'text-right tabular-nums' : ''
                      }`}
                      value={field === 'monto' ? formatMonto(fila[field]) : fila[field] ?? ''}
                      onChange={e =>
                        handleChangeFila(
                          index,
                          field,
                          field === 'monto' ? e.target.value.replace(/[^0-9]/g, '') : e.target.value
                        )
                      }
                    />
                  </td>
                ))}
                <td className='px-2 py-2 align-middle'>
                  <div className='flex items-center justify-center gap-1'>
                    {index === filasGastos.length - 1 && (
                      <button
                        type='button'
                        onClick={agregarFila}
                        title='Agregar gasto'
                        aria-label='Agregar gasto'
                        className='rounded-full p-1 text-accent2 transition-colors hover:bg-accent2/10 focus-visible:outline focus-visible:outline-2 focus-visible:outline-accent2'
                      >
                        <AddIcon fontSize='small' />
                      </button>
                    )}
                    {filasGastos.length > 1 && (
                      <button
                        type='button'
                        onClick={() => eliminarFila(index)}
                        title='Eliminar gasto'
                        aria-label={`Eliminar gasto, fila ${index + 1}`}
                        className='rounded-full p-1 text-red-500 transition-colors hover:bg-red-50 focus-visible:outline focus-visible:outline-2 focus-visible:outline-red-500'
                      >
                        <CancelIcon fontSize='small' />
                      </button>
                    )}
                  </div>
                </td>
              </tr>
            ))}
          </tbody>
        </table>
      </div>
    </div>
  )
}

export default TablaRendicionGasto
